export const periodChangeTypeOptions = [{
  value: 'year_over_year',
  label: 'Year-over-Year',
  shortLabel: 'YoY',
}, {
  value: 'period_over_period',
  label: 'Period-over-Period',
  shortLabel: 'PoP',
}];

export const intraPeriodKey = 'intra_period';
export const intraPeriodChangeTypeOption = {
  label: 'Intra-Period (Raw Data)',
  value: intraPeriodKey,
};

export const periodChangeTypeCaptures = {
  year_over_year: 'YoY',
  period_over_period: 'PoP',
};
